import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  Popup,
  FeatureGroup,
} from "react-leaflet";
import { FullscreenControl } from "react-leaflet-fullscreen";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { MarkerIcon, SchoolMarkerIcon } from "../icons/MarkerIcon";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import "react-leaflet-fullscreen/styles.css";

import { useState, useEffect, useMemo, useCallback, useRef } from "react";

const DefaultZoom = 8;

const schoolsLocation = [
  {
    name: "فرع مدينة نصر 1",
    address: "مدينة نصر - 36 نصر خسرو    01116872731 - 01025857670 - 01092539823  ",
    latlong: [30.046305875100266, 31.333621706587802],
    },
  {
    name: "فرع مدينة نصر 2",
    address: "مدينة نصر - 11 عبد الحي حجازي      01116872731 - 01025857670 - 01092539823  ",
    latlong: [30.052348293324226, 31.340655158945534],
    },
  {
    name: "فرع السودان",
    address: "امدرمان - الثورة الحارة السادسة - محطة السلالم    01116872731 - 01025857670 - 01092539823",
    latlong: [15.681098810554229, 32.493772841487285],
    },
];

const LeafletControl = ({ defaultLocation, name, contextForm }) => {
  const map = useRef();
  const [selectedPosition, setSelectedPosition] = useState(defaultLocation);
  const { handleCustomElementChange } = contextForm();

  useEffect(() => {
    if (!!defaultLocation) {
      map.current?.flyTo(
        { lat: defaultLocation[0], lng: defaultLocation[1] },
        18
      );
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setSelectedPosition([latitude, longitude]);
        map.current?.flyTo({ lat: latitude, lng: longitude }, 18);
      });
    }
  }, [map]);

  useEffect(() => {
    if (!!selectedPosition) {
      handleCustomElementChange(selectedPosition.join(","), name);
    }
  }, [selectedPosition, name]);

  const SearchBar = (props) => {
    const map = useMap(); // access to leaflet map
    const { provider } = props;

    useEffect(() => {
      const searchControl = new GeoSearchControl({
        provider,
        showMarker: true,
        autoClose: true,
      });

      map.addControl(searchControl); // this is how you add a control in vanilla leaflet
      return () => map.removeControl(searchControl);
    }, [props, map, provider]);

    return null; // don't want anything to show up from this comp
  };

  const SchoolMarkers = () => {
    return schoolsLocation.map((loc, key) => {
      return (
        <Marker
          key={key}
          position={loc.latlong}
          // interactive={false}
          icon={SchoolMarkerIcon}
        >
          <Popup>{`${loc.name}, ${loc.address}`}</Popup>
        </Marker>
      );
    });
  };

  const LocationMarker = ({ map }) => {
    const [position, setPosition] = useState(selectedPosition);
    const markerRef = useRef(null);

    const currentMap = map?.current;

    const onClick = useCallback((e) => {
      setPosition(e.latlng);
      setSelectedPosition([e.latlng.lat, e.latlng.lng]);
    }, []);

    useEffect(() => {
      currentMap?.on("click", onClick);
      return () => {
        currentMap?.off("click", onClick);
      };
    }, [currentMap, onClick]);

    const eventHandlers = useMemo(
      () => ({
        dragend() {
          const marker = markerRef.current;
          if (marker != null) {
            setPosition(marker.getLatLng());
            setSelectedPosition([
              marker.getLatLng().lat,
              marker.getLatLng().lng,
            ]);
          }
        },
      }),
      []
    );

    return !!position ? (
      <FeatureGroup interactive={true}>
        <Marker
          position={position}
          icon={MarkerIcon}
          draggable
          eventHandlers={eventHandlers}
          //   ondrag={handleMarkerDrag}
          ref={markerRef}
        >
          {/* <Popup>You are within {radius} meters from this point</Popup> */}
        </Marker>
        {/* <Circle radius={radius} center={position} /> */}
      </FeatureGroup>
    ) : null;
  };

  const isNotZero = (obj) => {
    if (!!obj) return obj[0] !== 0 && obj[1] !== 0;
    return false;
  };

  const displayMap = useMemo(
    () => (
      <MapContainer
        center={
          isNotZero(selectedPosition) ? selectedPosition : [30.0444, 31.2357]
        }
        attributionControl={false}
        // center={[19.61745, 37.21644]}
        zoom={DefaultZoom}
        style={{ height: "35vh" }}
        ref={map}
      >
        {/* <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              /> */}
        <TileLayer
          url={
            "https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
          }
          attribution="google maps"
        />
        <SearchBar provider={new OpenStreetMapProvider()} />
        <SchoolMarkers />
        {/* <Markers /> */}
        {map ? <LocationMarker map={map} /> : null}

        <FullscreenControl />
      </MapContainer>
    ),
    [map, selectedPosition]
  );
  return <div className="w-full">{displayMap}</div>;
};

export default LeafletControl;
